import React from 'react';
import { Modal } from 'react-bootstrap';
import './TeamScheduleModal.css';
import teamIcons from '../../utils/teamIcons';
import { getTeamSchedule, getByeWeeks } from '../../utils/scheduleHelpers';

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function formatKickoff(kickoffUtc) {
    const d = new Date(kickoffUtc);
    const weekday = d.toLocaleDateString('en-US', { weekday: 'short' });
    return `${weekday} ${MONTH_NAMES[d.getMonth()]} ${d.getDate()}`;
}

function TeamScheduleModal({ show, onHide, team, games }) {
    if (!team) return null;

    const TeamIcon = teamIcons[team];
    const schedule = getTeamSchedule(games, team);
    const byeWeeks = getByeWeeks(games);
    const byeWeek = byeWeeks[team];

    const maxWeek = Math.max(byeWeek || 0, ...schedule.map((g) => g.week), 0);
    const rows = [];
    for (let week = 1; week <= (maxWeek || 18); week++) {
        if (week === byeWeek) {
            rows.push({ week, bye: true });
            continue;
        }
        const game = schedule.find((g) => g.week === week);
        if (game) rows.push({ week, ...game });
    }

    return (
        <Modal show={show} onHide={onHide} className='team-schedule-modal'>
            <Modal.Header closeButton>
                <Modal.Title className='team-schedule-title'>
                    {TeamIcon && <TeamIcon />}
                    <span>{team} &mdash; 2026 Schedule</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {rows.length === 0 ? (
                    <p className='team-schedule-empty'>Schedule isn't available yet for this season.</p>
                ) : (
                    <ul className='team-schedule-list'>
                        {rows.map((row) => {
                            if (row.bye) {
                                return (
                                    <li key={row.week} className='team-schedule-row team-schedule-bye'>
                                        <span className='team-schedule-week'>Wk {row.week}</span>
                                        <span className='team-schedule-bye-label'>BYE WEEK</span>
                                    </li>
                                );
                            }
                            const OppIcon = teamIcons[row.opponent];
                            return (
                                <li key={row.week} className='team-schedule-row'>
                                    <span className='team-schedule-week'>Wk {row.week}</span>
                                    <span className='team-schedule-matchup'>
                                        <span className='team-schedule-vsat'>{row.isHome ? 'vs' : '@'}</span>
                                        {OppIcon && <OppIcon />}
                                        <span>{row.opponent}</span>
                                    </span>
                                    <span className='team-schedule-date'>{formatKickoff(row.kickoffUtc)}</span>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default TeamScheduleModal;
